import { get } from "../modules/env";

/**
 * Constructs a url given a list parts.
 */
export function joinUrlParts(...parts: string[]) {
  return parts.map((p) => p.replace(/^\/|\/$/g, "")).join("/");
}

/**
 * Builds the base URL for fetch requests.
 */
export function getBaseUrl(str: string = import.meta.url) {
  const url = new URL(str);

  const origin = url.origin === "null" ? "/" : url.origin;
  const root = get("ROOT")?.replace(/\/$/, "") ?? "";

  return joinUrlParts(origin, root);
}

/**
 * Builds a fully-qualified URL.
 */
export function getFullUrl(path: string, base = getBaseUrl()) {
  return /^http[s]?:\/\//.test(path) ? path : joinUrlParts(base, path);
}

/**
 * Builds an asset URL.
 */
export function getAssetUrl(
  pathname: string,
  base = get("ROOT", import.meta.url),
) {
  const root = base?.replace(/[^/]+\/?$/, "") ?? "";
  return joinUrlParts(root, pathname);
}
